exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".provider-tag{border-radius:4px;background-color:#439855;display:inline-block;padding:4px 16px;font-size:10px;font-weight:600;line-height:1.6;color:#fff}", ""]);

// exports
